'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var emotionTheming = require('emotion-theming');
var webfont = _interopDefault(require('webfontloader'));
var facepaint = _interopDefault(require('facepaint'));
var Hash = _interopDefault(require('react-feather/dist/icons/hash'));
var withSizes = _interopDefault(require('react-sizes'));
var match = _interopDefault(require('match-sorter'));
var flattendepth = _interopDefault(require('lodash.flattendepth'));
var SearchIcon = _interopDefault(require('react-feather/dist/icons/search'));
var placeholder = _interopDefault(require('polished/lib/mixins/placeholder'));
var ChevronDown = _interopDefault(require('react-feather/dist/icons/chevron-down'));
var Edit = _interopDefault(require('react-feather/dist/icons/edit-2'));
var reactCodemirror2 = require('react-codemirror2');
var PerfectScrollbar = _interopDefault(require('react-perfect-scrollbar'));
require('codemirror/mode/markdown/markdown');
require('codemirror/mode/javascript/javascript');
require('codemirror/mode/jsx/jsx');
require('codemirror/mode/css/css');
require('codemirror/addon/edit/matchbrackets');
require('codemirror/addon/edit/closetag');
require('codemirror/addon/fold/xml-fold');
var BaseCheck = _interopDefault(require('react-feather/dist/icons/check'));
var Clipboard = _interopDefault(require('react-feather/dist/icons/clipboard'));
var copy = _interopDefault(require('copy-text-to-clipboard'));
var reactPowerplug = require('react-powerplug');
var react = require('react');
var reactLive = require('react-live');
var rgba = _interopDefault(require('polished/lib/color/rgba'));
var Resizable = _interopDefault(require('re-resizable'));
var Maximize = _interopDefault(require('react-feather/dist/icons/maximize'));
var Minimize = _interopDefault(require('react-feather/dist/icons/minimize'));
var Refresh = _interopDefault(require('react-feather/dist/icons/refresh-cw'));
var Code = _interopDefault(require('react-feather/dist/icons/code'));
var hotkeys = _interopDefault(require('hotkeys-js'));
var getter = _interopDefault(require('lodash.get'));
var darken = _interopDefault(require('polished/lib/color/darken'));
var Smartphone = _interopDefault(require('react-feather/dist/icons/smartphone'));
var Tablet = _interopDefault(require('react-feather/dist/icons/tablet'));
var Monitor = _interopDefault(require('react-feather/dist/icons/monitor'));
var docz = require('docz');
var core = require('@emotion/core');
var styled = _interopDefault(require('@emotion/styled'));
var BaseTooltip = _interopDefault(require('rc-tooltip'));
var lighten = _interopDefault(require('polished/lib/color/lighten'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

const styles = {
    body: {
        fontFamily: "'Source Sans Pro', Helvetica, sans-serif",
        lineHeight: 1.6,
    },
    container: {
        width: ['100%', '100%', 920],
        padding: ['20px', '0 40px 40px'],
    },
    h1: {
        margin: ['30px 0 20px', '60px 0 20px', '40px 0 30px'],
        fontFamily: '"Playfair Display", serif',
        fontSize: [50, 50, 70],
        fontWeight: 700,
        letterSpacing: '-0.02em',
    },
    h2: {
        margin: ['40px 0 20px', '40px 0 30px'],
        lineHeight: ['1.2em', '1.5em'],
        fontFamily: '"Poppins", serif',
        fontWeight: 400,
        fontSize: 32,
        letterSpacing: '-0.02em',
    },
    h3: {
        margin: '25px 0 10px',
        fontSize: 22,
        fontWeight: 400,
    },
    h4: {
        margin: '25px 0 10px',
        fontSize: 18,
        fontWeight: 400,
    },
    h5: {
        margin: '20px 0 10px',
        fontSize: 16,
        fontWeight: 400,
    },
    h6: {
        margin: '20px 0 10px',
        fontSize: 16,
        fontWeight: 400,
        textTransform: 'uppercase',
    },
    ol: {
        padding: 0,
        margin: '10px 0 10px',
    },
    ul: {
        padding: 0,
        margin: '10px 0 10px',
    },
    playground: {
        padding: ['1.5em', '2em'],
    },
    code: {
        margin: '0 3px',
        borderRadius: '3px',
        fontFamily: '"Source Code Pro", monospace',
        padding: `2px 5px`,
        fontSize: '0.8em',
        border: '1px solid rgba(0, 0, 0, 0.02)',
    },
    pre: {
        fontFamily: '"Source Code Pro", monospace',
        fontSize: 14,
        lineHeight: 1.8,
    },
    paragraph: {
        margin: '10px 0 20px 0',
    },
    table: {
        overflowY: 'hidden',
        overflowX: ['initial', 'initial', 'initial', 'hidden'],
        display: ['block', 'block', 'block', 'table'],
        width: '100%',
        fontFamily: '"Source Code Pro", monospace',
        fontSize: 14,
    },
    blockquote: {
        margin: '25px 0',
        padding: '20px',
        fontStyle: 'italic',
        fontSize: 18,
    },
};

const white = '#FFFFFF';
const grayExtraLight = '#EEF1F5';
const grayLight = '#CED4DE';
const gray = '#7D899C';
const grayDark = '#2D3747';
const grayExtraDark = '#1D2330';
const dark = '#13161F';
const blue = '#0B5FFF';
const skyBlue = '#1FB6FF';
const negative = '#EB4D4B';

var colors = /*#__PURE__*/Object.freeze({
    white: white,
    grayExtraLight: grayExtraLight,
    grayLight: grayLight,
    gray: gray,
    grayDark: grayDark,
    grayExtraDark: grayExtraDark,
    dark: dark,
    blue: blue,
    skyBlue: skyBlue,
    negative: negative
});

const config = {
    colors,
    styles,
    radii: '2px',
    mode: 'light',
    showPlaygroundEditor: false,
    linesToScrollEditor: 18,
};

const get = (val, defaultValue) => (p) => getter(p, `theme.docz.${val}`, defaultValue);

const breakpoints = {
    mobile: 420,
    tablet: 920,
    desktop: 1120,
};
const mq = facepaint([
    `@media(min-width: ${breakpoints.mobile}px)`,
    `@media(min-width: ${breakpoints.tablet}px)`,
    `@media(min-width: ${breakpoints.desktop}px)`,
]);

const H1 = styled('h1') `
  position: relative;
  display: table;
  margin: 30px 0;
  ${p => mq(get('styles.h1')(p))};

  &:before {
    position: absolute;
    content: '';
    bottom: 5%;
    left: 0;
    width: 35%;
    height: 2px;
    background: ${get('colors.primary')};
  }
`;

const Icon = styled(Hash) `
  position: absolute;
  display: inline-block;
  top: 11px;
  left: -28px;
  opacity: 0;
  transition: opacity 0.2s;
  color: ${get('colors.primary')};
`;
const Heading = styled('h2') `
  position: relative;
  border-bottom: 1px dashed ${get('colors.border')};
  padding-bottom: 5px;
  ${p => mq(get('styles.h2')(p))};

  &:hover ${Icon.toString()} {
    opacity: 1;
  }
`;
const H2 = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (core.jsx(Heading, Object.assign({}, props),
        core.jsx(docz.Link, { "aria-hidden": true, to: { hash: `#${props.id}` } },
            core.jsx(Icon, { height: 20 })),
        children));
};

const H3 = styled('h3') `
  ${p => mq(get('styles.h3')(p))};
`;

const H4 = styled('h4') `
  ${p => mq(get('styles.h4')(p))};
`;

const H5 = styled('h5') `
  ${p => mq(get('styles.h5')(p))};
`;

const H6 = styled('h6') `
  ${p => mq(get('styles.h6')(p))};
`;

const Hr = styled('hr') `
  border: none;
  border-top: 1px dashed ${get('colors.border')};

  ${mq({
    margin: ['30px 0', '50px 0'],
})};
`;

const Blockquote = styled('blockquote') `
  background: ${get('colors.blockquoteBg')};
  border-left: 5px solid ${get('colors.blockquoteBorder')};
  color: ${get('colors.blockquoteColor')};
  ${get('styles.blockquote')};

  & > p {
    margin: 0;
    color: ${get('colors.blockquoteColor')};
  }
`;

const InlineCode = styled('code') `
  background: ${get('colors.codeBg')};
  color: ${get('colors.codeColor')};
  ${p => mq(get('styles.code')(p))};
`;

const OrderedList = styled('ol') `
  list-style: none;
  counter-reset: my-awesome-counter;

  & li {
    counter-increment: my-awesome-counter;
  }

  & li::before {
    content: counter(my-awesome-counter) '. ';
    color: ${get('colors.border')};
    font-weight: bold;
    font-family: 'Playfair Display', serif;
    margin-right: 5px;
  }

  ${p => mq(get('styles.ol')(p))};
`;

const UnorderedList = styled('ul') `
  list-style: none;

  & li::before {
    content: '● ';
    color: ${get('colors.border')};
    font-weight: bold;
    margin-right: 5px;
  }

  ${p => mq(get('styles.ul')(p))};
`;

const Wrapper = styled('div') `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
`;
const dash = core.keyframes `
  to {
    stroke-dashoffset: 1000;
  }
`;
const spinnerClass = (delay = 0) => core.css `
  stroke-dasharray: 100;
  animation: ${dash} 5s ${delay}s cubic-bezier(0.455, 0.03, 0.515, 0.955)
    infinite;
`;
const Lines = styled('path') `
  stroke: ${get('colors.primary')};
  stroke-width: 3px;
`;
const Path = styled('path') `
  fill: ${get('colors.primary')};
`;
const Spinner = ({ size = 60 }) => (core.jsx("svg", { width: size, height: size * 0.79, viewBox: "0 0 121 96" },
    core.jsx("g", null,
        core.jsx(Path, { d: "M94.4110629,60.8520717 C95.3815188,60.8520717 96.1684193,61.6483184 96.1684193,62.6308855 L96.1684193,84.1888093 C96.1684193,90.7014865 90.9354492,96 84.2817971,96 L11.6626593,96 C5.08322545,96 0.0693980867,90.6732777 9.65270039e-05,83.6092251 C-0.0048201377,83.1344165 0.178267091,82.6773865 0.508386007,82.3398291 C0.838270796,82.0025088 1.28802855,81.8126327 1.75698472,81.8126327 L20.0341004,81.8126327 L20.0341004,11.8111907 C20.0341004,5.29851351 25.2670706,0 31.6994728,0 L104.318611,0 C110.916775,0 115.930602,5.32672231 115.999903,12.3907749 C116.00482,12.8655835 115.821733,13.3226135 115.491614,13.6601709 C115.161729,13.9974912 114.711971,14.1873673 114.243015,14.1873673 L96.1677169,14.1873673 L96.1677169,27.6014816 C96.1677169,28.5840486 95.3810506,29.3805324 94.4105946,29.3805324 C93.4401387,29.3805324 92.6534723,28.5842856 92.6534723,27.6014816 L92.6534723,12.4083165 L92.6534723,11.8111907 C92.6534723,11.6092251 92.6586231,11.4084449 92.6841429,10.9981135 C92.6928056,10.8698701 92.7005318,10.7413897 92.7436112,10.3687491 C92.7574246,10.2552027 92.7695992,10.1411823 92.831877,9.76735641 C92.8501389,9.66186972 92.8667619,9.55614598 92.9475357,9.18611289 C92.970246,9.08560423 92.9913174,8.98462146 93.0908213,8.61601067 C93.1175118,8.52000593 93.1425634,8.42352709 93.1715951,8.32870759 C93.1992221,8.23862907 93.230361,8.15044694 93.3528093,7.78396958 C93.3848847,7.69483925 93.4202379,7.60736827 93.5590751,7.25132105 C93.5953648,7.16385007 93.6349322,7.07803842 93.7896901,6.73147316 C93.8299599,6.64613561 93.8735075,6.56245741 94.0439519,6.22513704 C94.0882019,6.14193293 94.1354955,6.06062522 94.3213923,5.7327868 C94.3693883,5.65219023 94.4199597,5.57349005 94.6208406,5.25560768 C94.6723485,5.17809275 94.7261977,5.10223715 94.9425309,4.79383673 C94.9970825,4.71940343 95.0537412,4.64710356 95.2848244,4.34889624 C95.3424196,4.27754457 95.402122,4.20832634 95.647487,3.92078621 C95.7074235,3.85346437 95.7694671,3.78803892 95.9815861,3.55810163 L31.7001752,3.55810163 C27.2058754,3.55810163 23.5492816,7.26009186 23.5492816,11.8109536 L23.5492816,81.8126327 L74.3763566,81.8126327 C75.3400229,81.8126327 76.1238797,82.5984493 76.1334789,83.5741419 C76.1831138,88.6294434 79.6861203,92.4418984 84.503047,92.4418984 C88.9973468,92.4418984 92.6539406,88.7399081 92.6539406,84.1890464 L92.6539406,62.6311225 C92.6539406,61.6485555 93.4406069,60.8520717 94.4110629,60.8520717 Z M96.2578558,10.5918119 C96.2562169,10.6041385 96.2550463,10.6167021 96.2543439,10.6287915 L112.318258,10.6287915 C111.563199,6.49371327 108.371815,3.55786459 104.339214,3.55786459 C104.270849,3.55786459 104.203186,3.56094622 104.135289,3.56260556 C104.072075,3.5642649 104.008861,3.564739 103.946115,3.56758358 C103.83748,3.57279866 103.729781,3.58085831 103.622317,3.59034026 C103.604289,3.59176256 103.586262,3.59271075 103.568468,3.59437009 C103.45117,3.60551138 103.334575,3.61926021 103.218682,3.63537952 C103.211424,3.63632772 103.204167,3.63727591 103.196909,3.63822411 C103.075397,3.65529162 102.954587,3.67520371 102.834948,3.69772334 C102.834246,3.69796039 102.83331,3.69796039 102.832607,3.69819744 C101.371187,3.97364808 100.046965,4.64283668 98.9709182,5.5917428 C98.9681087,5.59435034 98.965065,5.59672083 98.9622555,5.59932836 C98.8779698,5.67376167 98.7955572,5.75009136 98.7145493,5.82784335 C98.7058866,5.83637711 98.6972239,5.84467381 98.6885612,5.85297052 C98.6117675,5.92740382 98.5363787,6.00349647 98.4623946,6.08077436 C98.4504541,6.09310089 98.4389819,6.10566448 98.4272756,6.11799101 C98.3558669,6.19360956 98.2858629,6.27017631 98.2174979,6.34840239 C98.204855,6.36286236 98.1924463,6.37755939 98.1800376,6.39201936 C98.1128431,6.4700084 98.0463511,6.54894563 97.9819662,6.6295422 C97.9714305,6.64281693 97.961363,6.65632871 97.9508273,6.66960344 C97.8850377,6.75304459 97.8201845,6.8371969 97.7574385,6.92300854 C97.7555655,6.92561608 97.7539266,6.92798657 97.7520536,6.9305941 C97.55726,7.19822213 97.3790895,7.47888785 97.2168395,7.76974665 C97.2025578,7.79558497 97.1871054,7.82071213 97.1730578,7.8467875 C97.136534,7.91387229 97.1023515,7.98214233 97.0677007,8.05041237 C97.044288,8.09639982 97.0201729,8.14191318 96.9976968,8.18837473 C96.9674944,8.25071855 96.9389309,8.31448467 96.9101333,8.37777668 C96.8857841,8.4313497 96.8612008,8.48492271 96.8380222,8.53920687 C96.8118,8.6001284 96.7872167,8.66152403 96.7626334,8.7231567 C96.7392207,8.78170774 96.7160421,8.84002173 96.6940342,8.89904687 C96.671558,8.95878315 96.6502525,9.01923058 96.629181,9.07967801 C96.6074072,9.14225888 96.5863358,9.20483975 96.5662009,9.26789471 C96.5472366,9.32691985 96.5287406,9.38618203 96.5111811,9.44591832 C96.4917485,9.51181787 96.4732525,9.57842856 96.4552248,9.64503926 C96.4395383,9.70335325 96.4240859,9.76190429 96.40957,9.82069238 C96.3924787,9.89062176 96.3767922,9.96102524 96.3613399,10.0316658 C96.3489311,10.0885575 96.3362883,10.1454492 96.3250502,10.202815 C96.3103002,10.2781965 96.2974232,10.3540521 96.2847804,10.4299076 C96.2756494,10.4837177 96.2658161,10.5375278 96.2578558,10.5918119 Z M11.6624252,92.4418984 L75.9979194,92.4418984 C75.9649075,92.4068152 75.9335345,92.3698355 75.9009909,92.3342782 C75.8553361,92.284498 75.8099155,92.2344807 75.7651973,92.1837523 C75.6987052,92.1083708 75.6331497,92.0320411 75.5685307,91.9547632 C75.5252172,91.9030866 75.4819037,91.8514099 75.4392927,91.7990222 C75.3746736,91.7193738 75.3114594,91.637829 75.2487134,91.5560472 C75.2089118,91.5041335 75.1688761,91.452931 75.1297769,91.4003062 C75.0646896,91.3128352 75.0019436,91.2234678 74.9391976,91.1338634 C74.9050151,91.0847943 74.8698961,91.0366734 74.8361818,90.9871302 C74.7633683,90.8797471 74.6928961,90.7702306 74.6233604,90.660003 C74.602289,90.6265791 74.580047,90.5943405 74.5592097,90.5606795 C74.4700073,90.4165539 74.3836145,90.2700578 74.3000312,90.1211912 C74.2777891,90.081604 74.2569519,90.0408316 74.2351781,90.0007704 C74.1750074,89.8907798 74.1153051,89.7805521 74.0581781,89.6684281 C74.0282099,89.60964 74.0003488,89.5499037 73.971317,89.4906415 C73.9247258,89.3951109 73.8779004,89.2993432 73.8334163,89.2021532 C73.8032139,89.1362536 73.7744163,89.0694059 73.7453846,89.0027952 C73.7048806,88.9098721 73.6646108,88.816949 73.6259799,88.7228406 C73.5974164,88.6529113 73.5700236,88.5822707 73.5423966,88.5116302 C73.5061069,88.4187071 73.4707538,88.3253099 73.4365712,88.2309645 C73.4101149,88.1584276 73.3845951,88.0854166 73.3595435,88.0121685 C73.3269998,87.917112 73.2953927,87.8213443 73.2649562,87.7251025 C73.2415435,87.6516174 73.218365,87.5778952 73.196357,87.5036989 C73.1668571,87.4048496 73.1392301,87.3050521 73.1118372,87.2050175 C73.0919364,87.1320065 73.0715674,87.0589955 73.0528373,86.9852733 C73.0259127,86.8802608 73.0013293,86.7738259 72.9769801,86.667391 C72.9610595,86.5972246 72.9439683,86.5275322 72.9289841,86.4566546 C72.9036984,86.3386044 72.8814564,86.2188948 72.8592143,86.0991851 C72.8479762,86.0387377 72.8353334,85.9792385 72.8250318,85.918554 C72.7938929,85.7374488 72.7657977,85.5551583 72.7416826,85.3709714 L21.7919251,85.3709714 L3.68338077,85.3709714 C4.43844,89.5060497 7.62982365,92.4418984 11.6624252,92.4418984 Z M120.998408,32.7899677 C120.998647,32.8098599 121.000556,32.8297522 120.99984,32.850118 C120.998408,32.9064794 120.993634,32.9621303 120.986951,33.0170708 C120.986712,33.0203861 120.986712,33.0234647 120.986235,33.0267801 C120.975971,33.1077699 120.958785,33.1863916 120.938019,33.2635925 C120.933962,33.2787485 120.929665,33.2934308 120.92513,33.30835 C120.878347,33.4655934 120.810559,33.6131276 120.72463,33.7488211 C120.716514,33.7616089 120.708399,33.77416 120.700045,33.7867111 C120.654455,33.854913 120.605285,33.9202732 120.551102,33.981134 C120.54776,33.9846862 120.54418,33.9880016 120.540838,33.9917906 C120.485939,34.0526514 120.426267,34.1087759 120.363491,34.1615851 C120.358478,34.1658477 120.354659,34.1708208 120.349647,34.1748466 C116.038893,37.7064298 112.307441,41.2448806 107.873046,46.0062306 C102.802778,51.4498371 91.7857706,58.7815489 86.0428726,60.5339606 C83.3864839,61.3445694 81.1912456,61.9366004 79.2545094,62.4594822 C75.5209096,63.4666453 72.7568714,64.2130779 69.3242606,65.8091935 L66.5163033,75.703689 C66.2938436,76.487538 65.5749072,77 64.7927178,77 C64.632079,77 64.4685759,76.9786869 64.3062662,76.9332189 C63.354129,76.6670418 62.7994119,75.6852176 63.0674615,74.7405729 L66.0950142,64.0724114 C66.1009815,64.0513351 66.1074262,64.0304956 66.1141095,64.0098929 C66.2733162,63.5189808 66.4310907,63.0273583 66.589104,62.5354989 C68.5186795,56.5263844 70.5141337,50.3124272 74.8387316,45.4144364 C84.7202875,34.2226827 104.265713,30.6427897 119.255011,31.0276098 C119.339269,31.0297412 119.421379,31.0396873 119.502295,31.0529488 C119.520435,31.0557905 119.538337,31.0588691 119.556239,31.0624213 C119.637155,31.0782877 119.716639,31.0979431 119.793259,31.1239925 C119.793736,31.1239925 119.794214,31.1242293 119.794691,31.1244661 C119.871788,31.1507523 119.945305,31.1836692 120.017151,31.2196647 C120.030995,31.2265323 120.0446,31.233163 120.058205,31.2405042 C120.128619,31.2783942 120.196885,31.3198363 120.261331,31.3662516 C120.269208,31.3719351 120.276369,31.378329 120.284007,31.3840125 C120.341293,31.4268755 120.395714,31.473054 120.447271,31.5223109 C120.459445,31.5339147 120.472095,31.5450449 120.48403,31.5571224 C120.53869,31.6120628 120.58977,31.6703187 120.636792,31.7318899 C120.646101,31.7442042 120.654694,31.7572288 120.663764,31.7697799 C120.706489,31.8287462 120.745635,31.8900806 120.780961,31.9540199 C120.785735,31.9630188 120.791225,31.9713072 120.795998,31.9803061 C120.834189,32.0527707 120.866651,32.1285507 120.894816,32.2064619 C120.896965,32.2126191 120.900545,32.2183026 120.902693,32.2244597 C120.905319,32.2318009 120.906274,32.2396157 120.90866,32.2471937 C120.959502,32.3997009 120.989815,32.5607333 120.996976,32.7279228 C120.997692,32.7487623 120.998169,32.769365 120.998408,32.7899677 Z M77.5340269,47.756511 C75.2953469,50.2920613 73.752689,53.2567157 72.4766485,56.4636291 C76.7888345,52.5955355 82.6281636,48.2464759 88.0376107,44.6611362 C91.3895441,42.4395991 97.3876024,38.6593629 103.660632,35.6411889 C101.191855,36.0456645 98.7963549,36.5581265 96.5295094,37.1757332 C88.0946578,39.4737607 81.7037145,43.0337614 77.5340269,47.756511 Z M105.24172,43.5935859 C108.084287,40.541311 110.64878,37.9761591 113.255998,35.5938264 C107.252689,37.4175187 99.0698944,41.6242541 90.0278137,47.6172653 C84.8055001,51.0785153 79.7992015,54.8284396 75.9309802,58.1760196 C74.9697728,59.0079415 74.1544054,59.7489275 73.4588607,60.4098709 C75.0136919,59.9201429 76.5859475,59.4953014 78.3143067,59.0290178 C80.2245483,58.513714 82.3894729,57.9292611 84.9897693,57.1359395 C89.6492502,55.7143547 100.307028,48.8917896 105.24172,43.5935859 Z", id: "Combined-Shape", fill: "#1F2D3D" }),
        core.jsx(Lines, { d: "M31.5,18.5 L38.5,18.5", id: "Line", strokeWidth: "5", strokeLinecap: "round", strokeLinejoin: "round", css: spinnerClass(1.5) }),
        core.jsx(Lines, { d: "M47.75,18.5 L86.25,18.5", id: "Line", strokeWidth: "5", "stroke-linecap": "round", strokeLinejoin: "round", css: spinnerClass(0.2) }),
        core.jsx(Lines, { d: "M30.9375,38.5 L72.0625,38.5", id: "Line", strokeWidth: "5", "stroke-linecap": "round", strokeLinejoin: "round", css: spinnerClass(1) }),
        core.jsx(Lines, { d: "M31,56.5 L59,56.5", id: "Line", strokeWidth: "5", "stroke-linecap": "round", strokeLinejoin: "round", css: spinnerClass(3) }),
        core.jsx(Lines, { d: "M31.375,72.5 L50.625,72.5", id: "Line", strokeWidth: "5", "stroke-linecap": "round", strokeLinejoin: "round", css: spinnerClass(2) }))));
const Loading = () => (core.jsx(Wrapper, null,
    core.jsx(Spinner, null)));

const LinkStyled = styled('a') `
  &,
  &:visited,
  &:active {
    text-decoration: none;
    color: ${get('colors.link')};
  }

  &:hover {
    color: ${get('colors.link')};
  }
`;
const Link = (_a) => {
    var { href } = _a, props = __rest(_a, ["href"]);
    const isInternal = href && href.startsWith('/');
    const Component = isInternal
        ? LinkStyled.withComponent(docz.Link)
        : LinkStyled;
    return isInternal ? (core.jsx(Component, Object.assign({}, props, { to: href }))) : (core.jsx(Component, Object.assign({}, props, { href: href })));
};

const octocatWave = core.keyframes `
  0%, 100% {
    transform: rotate(0);
  }
  20%, 60% {
    transform: rotate(-25deg);
  }
  40%, 80% {
    transform: rotate(10deg);
  }
`;
const Link$1 = styled('a') `
  &:hover .octo-arm {
    animation: ${octocatWave} 560ms ease-in-out;
  }

  & .octo-arm {
    transform-origin: 130px 106px;
  }

  @media screen and (max-width: 500px) {
    &:hover .octo-arm {
      animation: none;
    }
    & .octo-arm {
      animation: ${octocatWave} 560ms ease-in-out;
    }
  }
`;
const Svg = styled('svg') `
  z-index: 99;
  fill: ${get('colors.primary')};
  color: ${get('colors.background')};
  position: absolute;
  top: 0;
  border: 0;
  right: 0;
`;
const GithubLink = ({ repository }) => (core.jsx(Link$1, { href: repository, target: "_blank", "aria-label": "View source on Github" },
    core.jsx(Svg, { width: "80", height: "80", viewBox: "0 0 250 250", "aria-hidden": "true" },
        core.jsx("path", { d: "M0,0 L115,115 L130,115 L142,142 L250,250 L250,0 Z" }),
        core.jsx("path", { className: "octo-arm", fill: "currentColor", d: "M128.3,109.0 C113.8,99.7 119.0,89.6 119.0,89.6 C122.0,82.7 120.5,78.6 120.5,78.6 C119.2,72.0 123.4,76.3 123.4,76.3 C127.3,80.9 125.5,87.3 125.5,87.3 C122.9,97.6 130.6,101.9 134.4,103.2" }),
        core.jsx("path", { className: "octo-body", fill: "currentColor", d: "M115.0,115.0 C114.9,115.1 118.7,116.5 119.8,115.4 L133.7,101.6 C136.9,99.2 139.9,98.4 142.2,98.6 C133.8,88.0 127.5,74.4 143.8,58.0 C148.5,53.4 154.0,51.2 159.7,51.0 C160.3,49.4 163.2,43.6 171.4,40.1 C171.4,40.1 176.1,42.5 178.8,56.2 C183.1,58.6 187.2,61.8 190.9,65.4 C194.5,69.0 197.7,73.2 200.1,77.6 C213.8,80.2 216.3,84.9 216.3,84.9 C212.7,93.1 206.9,96.0 205.4,96.6 C205.1,102.4 203.0,107.8 198.3,112.5 C181.9,128.9 168.3,122.5 157.7,114.1 C157.9,116.9 156.7,120.9 152.7,124.9 L141.0,136.5 C139.8,137.7 141.6,141.9 141.8,141.8 Z" }))));

const sidebarPrimary = get('colors.sidebarPrimary');
const primaryColor = get('colors.primary');
const Wrapper$1 = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 24px;

  a,
  a:hover,
  a:visited {
    text-decoration: none;
  }

  &:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background: ${p => sidebarPrimary(p) || primaryColor(p)};
  }

  @media screen and (max-width: ${breakpoints.desktop}px) {
    &:before {
      height: ${p => (p.showBg ? '3px' : 0)};
    }
  }
`;
const LogoImg = styled('img') `
  padding: 0;
  margin: 5px 0;
`;
const LogoText = styled('h1') `
  margin: 5px 0;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.015em;
  color: ${get('colors.sidebarText')};
`;
const Logo = ({ showBg }) => (core.jsx(docz.ThemeConfig, null, ({ title, themeConfig: { logo } }) => (core.jsx(Wrapper$1, { showBg: showBg },
    core.jsx(docz.Link, { to: "/" }, logo ? (core.jsx(LogoImg, { src: logo.src, width: logo.width, alt: title })) : (core.jsx(LogoText, null, title)))))));

const sidebarBorder = get('colors.sidebarBorder', '#CED4DE');
const sidebarText = get('colors.sidebarText', '#13161F');
const Wrapper$2 = styled('div') `
  display: flex;
  align-items: center;
  padding: 5px 24px;
  margin-bottom: 20px;
  border-top: 1px dotted ${sidebarBorder};
  border-bottom: 1px dotted ${sidebarBorder};
  opacity: 1;
`;
const Icon$1 = styled(SearchIcon) `
  stroke: ${sidebarText};
  width: 20px;
  opacity: 0.5;
`;
const Input = styled('input') `
  outline: none;
  width: 100%;
  padding: 10px;
  background: transparent;
  border: none;
  font-size: 16px;
  color: ${sidebarText};

  ${p => placeholder({
    color: rgba(sidebarText(p), 0.5),
})};
`;
const Search = ({ onSearch }) => (core.jsx(Wrapper$2, null,
    core.jsx(Icon$1, null),
    core.jsx(Input, { type: "text", placeholder: "Search here...", onChange: (ev) => {
            onSearch && onSearch(ev.target.value);
        } })));

const sidebarPrimary$1 = get('colors.sidebarPrimary');
const primaryColor$1 = get('colors.primary');
const Submenu = styled.div `
  display: flex;
  flex-direction: column;
  margin: 5px 0 0 24px;
`;
const SmallLink = styled(docz.Link) `
  position: relative;
  font-size: 14px;
  padding: 0 0 5px 16px;
  text-decoration: none;
  opacity: 0.5;
  transition: opacity 0.2s;

  &,
  &:visited,
  &.active {
    color: ${get('colors.sidebarText')};
  }

  &.active {
    opacity: 1;
  }

  &:before {
    z-index: 1;
    position: absolute;
    display: block;
    content: '';
    top: 1px;
    left: 0;
    width: 0;
    height: 20px;
    background: ${p => sidebarPrimary$1(p) || primaryColor$1(p)};
    transition: width 0.2s;
  }

  &.active:before {
    width: 2px;
  }
`;
const isSmallLinkActive = (slug) => (m, location) => slug === location.hash.slice(1, Infinity);
const getHeadings = (route, docs) => {
    const doc = docs.find(doc => doc.route === route);
    const headings = getter(doc, 'headings');
    return headings ? headings.filter(heading => heading.depth === 2) : [];
};
const MenuHeadings = ({ route, onClick }) => (core.jsx(docz.Docs, null, ({ docs }) => {
    const headings = getHeadings(route, docs);
    return (headings.length > 0 && (core.jsx(Submenu, null, headings.map((heading) => (core.jsx(SmallLink, { key: heading.slug, onClick: onClick, to: { pathname: route, hash: heading.slug }, isActive: isSmallLinkActive(heading.slug) }, heading.value))))));
}));

const activeWrapper = core.css `
  padding-left: 0;

  &:after {
    width: 1px;
  }
`;
const Wrapper$3 = styled.div `
  position: relative;
  transition: padding 0.2s;

  &:after {
    position: absolute;
    display: block;
    content: '';
    top: 30px;
    left: 24px;
    width: 0;
    height: calc(100% - 36px);
    border-left: 1px dashed ${get('colors.sidebarBorder')};
    transition: width 0.2s;
  }

  ${p => p.active && activeWrapper};
`;
const linkStyle = ({ colors }) => core.css `
  position: relative;
  display: block;
  padding: 4px 24px;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: -0.02em;
  color: ${colors.sidebarText};
  text-decoration: none;
  transition: color 0.2s;

  &:hover,
  &:visited {
    color: ${colors.sidebarText};
  }

  &:hover,
  &.active {
    color: ${colors.sidebarPrimary || colors.primary};
    font-weight: 600;
  }
`;
const LinkAnchor = styled('a') `
  ${p => linkStyle(p.theme.docz)};
`;
const getActiveFromClass = (el) => Boolean(el && el.classList.contains('active'));
class MenuLink extends react.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
        };
        this.updateActive = (prevActive) => {
            const active = getActiveFromClass(this.$el);
            if (prevActive !== active)
                this.setState({ active });
        };
        this.$el = null;
    }
    componentDidUpdate(prevProps, prevState) {
        this.updateActive(prevState.active);
    }
    componentDidMount() {
        this.updateActive(this.state.active);
    }
    render() {
        const { active } = this.state;
        const { item, children, onClick, innerRef } = this.props;
        const commonProps = (config) => ({
            children,
            onClick,
            css: linkStyle(config.themeConfig),
        });
        const refFn = (node) => {
            innerRef && innerRef(node);
            this.$el = node;
        };
        return (core.jsx(Wrapper$3, { active: active },
            core.jsx(docz.ThemeConfig, null, config => {
                const route = item.route === '/' ? '/' : item.route;
                const props = Object.assign({}, commonProps(config));
                return item.route ? (core.jsx(docz.Link, Object.assign({}, props, { innerRef: refFn, to: route }))) : (core.jsx(LinkAnchor, Object.assign({}, props, { ref: refFn, href: item.href || '#', target: item.href ? '_blank' : '_self' })));
            }),
            active && item.route && core.jsx(MenuHeadings, { route: item.route })));
    }
}

const Wrapper$4 = styled('div') `
  display: flex;
  flex-direction: column;
`;
const List = styled.dl `
  flex: 1;
  overflow-y: auto;
  visibility: ${p => (p.opened ? 'visible' : 'hidden')};
  max-height: ${p => (p.opened ? 'auto' : '0px')};
`;
const iconRotate = (p) => (p.opened ? '-180deg' : '0deg');
const Icon$2 = styled.div `
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%) rotate(${iconRotate});
  transform-origin: 50% 50%;
  transition: transform 0.3s;

  & svg {
    stroke: ${get('colors.sidebarText')};
  }
`;
class Menu extends react.Component {
    constructor(props) {
        super(props);
        this.state = {
            opened: false,
            hasActive: false,
        };
        this.toggle = () => {
            this.setState(state => ({ opened: !state.opened }));
        };
        this.checkActiveLink = () => {
            const hasActive = this.$els.some((el) => getActiveFromClass(el));
            if (hasActive)
                this.setState({ hasActive, opened: true });
        };
        this.$els = [];
    }
    componentDidMount() {
        this.checkActiveLink();
    }
    render() {
        const { item, sidebarToggle, collapseAll } = this.props;
        const show = collapseAll || this.state.opened;
        const hasChildren = !item.href && item.menu && item.menu.length > 0;
        const hasToggle = !item.href && !item.route;
        const handleToggle = (ev) => {
            ev.preventDefault();
            this.toggle();
        };
        return (core.jsx(Wrapper$4, null,
            core.jsx(MenuLink, Object.assign({ item: item }, hasToggle && { onClick: handleToggle }),
                item.name,
                hasChildren && (core.jsx(Icon$2, { opened: show },
                    core.jsx(ChevronDown, { size: 15 })))),
            hasChildren && (core.jsx(List, { opened: show }, item.menu &&
                item.menu.map(item => (core.jsx("dt", { key: item.id },
                    core.jsx(MenuLink, { item: item, onClick: sidebarToggle, innerRef: (node) => {
                            this.$els = this.$els.concat([node]);
                        } }, item.name))))))));
    }
}

const Docz = ({ width = 100, className }) => (core.jsx("svg", { width: width, height: width * 0.29, className: className, viewBox: "0 0 385 112" },
    core.jsx("path", { d: "M146.8,111.2 C129.4,111.2 116.35,97.25 116.35,77.45 C116.35,58.4 130.15,43.1 147.85,43.1 C156.25,43.1 162.4,46.25 166.15,49.4 L166.15,14 L156.25,14 L156.25,0.2 L182.5,0.2 L182.5,96.5 L192.25,96.5 L192.25,110 L166.15,110 L166.15,102.8 C161.35,107.45 155.2,111.2 146.8,111.2 Z M150.55,97.1 C156.7,97.1 161.65,94.4 166.15,90.5 L166.15,62.3 C161.8,59.3 156.7,57.2 150.55,57.2 C141.4,57.2 133.15,64.25 133.15,77.3 C133.15,89.9 140.95,97.1 150.55,97.1 Z M225.45,111.2 C203.7,111.2 190.5,95.45 190.5,77.15 C190.5,59.15 204,43.1 225.45,43.1 C247.2,43.1 260.4,58.85 260.4,77.15 C260.4,95.15 246.9,111.2 225.45,111.2 Z M225.45,97.55 C236.1,97.55 243.6,89.15 243.6,77.15 C243.6,65.15 236.1,56.75 225.45,56.75 C214.8,56.75 207.3,65.15 207.3,77.15 C207.3,89.15 214.8,97.55 225.45,97.55 Z M296.9,111.2 C276.2,111.2 260.6,97.7 260.6,76.55 C260.6,59.45 274.4,43.1 293.9,43.1 C311.9,43.1 323.75,54.8 323.75,65.15 C323.75,72.05 319.1,76.25 313.25,76.25 C307.85,76.25 303.35,71.75 303.35,66.35 C303.35,64.4 304.25,62.15 305.45,60.8 C304.25,59.15 300.2,56.3 293.75,56.3 C286.25,56.3 276.95,62.45 276.95,76.85 C276.95,89.45 286.55,97.4 298.25,97.4 C306.2,97.4 313.1,95.15 321.65,90.5 L320.3,105.2 C313.25,109.25 306.5,111.2 296.9,111.2 Z M323.65,110 L323.65,100.4 L363.25,57.2 L340,57.2 L340,69.35 L326.05,69.35 L326.05,44.3 L383.65,44.3 L383.65,53.75 L344.05,96.95 L370.6,96.95 L370.6,84.8 L384.4,84.8 L384.4,110 L323.65,110 Z M87,18.5 C87,19.3284477 86.2115475,20 85.2391775,20 L47.760588,20 C46.7882179,20 46,19.3284477 46,18.5 C46,17.6715523 46.7882179,17 47.760588,17 L85.239412,17 C86.2117821,17 87,17.6713524 87,18.5 Z M31.8615438,20 C30.833168,20 30,19.3284477 30,18.5 C30,17.6715523 30.833416,17 31.8615438,17 L38.1384562,17 C39.166584,17 40,17.6715523 40,18.5 C40,19.3284477 39.166584,20 38.1384562,20 L31.8615438,20 Z M31.7657124,71 L50.2342876,71 C51.2094879,71 52,71.6713524 52,72.5 C52,73.3284477 51.2094879,74 50.2342876,74 L31.7657124,74 C30.7905121,74 30,73.3286476 30,72.5 C30,71.6715523 30.7905121,71 31.7657124,71 Z M60,56.5 C60,57.3284477 59.1933987,58 58.1988865,58 L31.8011135,58 C30.8063613,58 30,57.3286476 30,56.5 C30,55.6715523 30.8063613,55 31.8011135,55 L58.1988865,55 C59.1936387,55 60,55.6713524 60,56.5 Z M73,38.5 C73,39.3286475 72.1908104,40.0001998 71.192569,40 L31.807431,40 C30.8091896,40 30,39.3284477 30,38.5 C30,37.6715523 30.8091896,37 31.807431,37 L71.192569,37 C72.1908104,37 73,37.6713524 73,38.5 Z M94.4110629,60.8520717 C95.3815188,60.8520717 96.1684193,61.6483184 96.1684193,62.6308855 L96.1684193,84.1888093 C96.1684193,90.7014865 90.9354492,96 84.503047,96 L84.2817971,96 L11.6626593,96 C5.08322545,96 0.0693980867,90.6732777 9.65270039e-05,83.6092251 C-0.0048201377,83.1344165 0.178267091,82.6773865 0.508386007,82.3398291 C0.838270796,82.0025088 1.28802855,81.8126327 1.75698472,81.8126327 L20.0341004,81.8126327 L20.0341004,11.8111907 C20.0341004,5.29851351 25.2670706,0 31.6994728,0 L104.318611,0 C110.916775,0 115.930602,5.32672231 115.999903,12.3907749 C116.00482,12.8655835 115.821733,13.3226135 115.491614,13.6601709 C115.161729,13.9974912 114.711971,14.1873673 114.243015,14.1873673 L96.1677169,14.1873673 L96.1677169,27.6014816 C96.1677169,28.5840486 95.3810506,29.3805324 94.4105946,29.3805324 C93.4401387,29.3805324 92.6534723,28.5842856 92.6534723,27.6014816 L92.6534723,12.4083165 L92.6534723,11.8111907 C92.6534723,11.6092251 92.6586231,11.4084449 92.6684564,11.2090869 C92.6719683,11.1384463 92.6794604,11.068517 92.6841429,10.9981135 C92.6928056,10.8698701 92.7005318,10.7413897 92.7131747,10.6143316 C92.7213691,10.5318386 92.7337778,10.4507679 92.7436112,10.3687491 C92.7574246,10.2552027 92.7695992,10.1411823 92.7864564,10.0285841 C92.7995675,9.94087609 92.8168929,9.85459035 92.831877,9.76735641 C92.8501389,9.66186972 92.8667619,9.55614598 92.8878333,9.45160749 C92.905627,9.36247716 92.9276349,9.27453208 92.9475357,9.18611289 C92.970246,9.08560423 92.9913174,8.98462146 93.016369,8.88506099 C93.0393134,8.79450837 93.0660039,8.70561509 93.0908213,8.61601067 C93.1175118,8.52000593 93.1425634,8.42352709 93.1715951,8.32870759 C93.1992221,8.23862907 93.230361,8.15044694 93.2598609,8.06131661 C93.2905316,7.96863055 93.3197974,7.87547039 93.3528093,7.78396958 C93.3848847,7.69483925 93.4202379,7.60736827 93.4544204,7.51918613 C93.4890712,7.42981876 93.5223172,7.33974023 93.5590751,7.25132105 C93.5953648,7.16385007 93.6349322,7.07803842 93.673329,6.99151563 C93.71196,6.90475579 93.7491861,6.8172848 93.7896901,6.73147316 C93.8299599,6.64613561 93.8735075,6.56245741 93.9158845,6.47806805 C93.9582615,6.39344165 93.9994678,6.30834115 94.0439519,6.22513704 C94.0882019,6.14193293 94.1354955,6.06062522 94.1816185,5.9788434 C94.2277415,5.89658749 94.2731621,5.81385747 94.3213923,5.7327868 C94.3693883,5.65219023 94.4199597,5.57349005 94.4698287,5.49407872 C94.5196977,5.41419329 94.5690985,5.33407082 94.6208406,5.25560768 C94.6723485,5.17809275 94.7261977,5.10223715 94.7793445,5.02590745 C94.8334278,4.94815546 94.8868087,4.87016643 94.9425309,4.79383673 C94.9970825,4.71940343 95.0537412,4.64710356 95.1099316,4.57409255 C95.1679951,4.49871105 95.2251221,4.42285545 95.2848244,4.34889624 C95.3424196,4.27754457 95.402122,4.20832634 95.4613561,4.13839696 C95.5229315,4.06538594 95.5840386,3.99213788 95.647487,3.92078621 C95.7074235,3.85346437 95.7694671,3.78803892 95.8308083,3.72190232 C95.8813797,3.66738111 95.9300781,3.6114376 95.9815861,3.55810163 L31.7001752,3.55810163 C27.2058754,3.55810163 23.5492816,7.26009186 23.5492816,11.8109536 L23.5492816,81.8126327 L74.3763566,81.8126327 C75.3400229,81.8126327 76.1238797,82.5984493 76.1334789,83.5741419 C76.1831138,88.6294434 79.6861203,92.4418984 84.2817971,92.4418984 L84.503047,92.4418984 C88.9973468,92.4418984 92.6539406,88.7399081 92.6539406,84.1890464 L92.6539406,62.6311225 C92.6539406,61.6485555 93.4406069,60.8520717 94.4110629,60.8520717 Z M96.2578558,10.5918119 C96.2562169,10.6041385 96.2550463,10.6167021 96.2543439,10.6287915 L112.318258,10.6287915 C111.563199,6.49371327 108.371815,3.55786459 104.339214,3.55786459 C104.270849,3.55786459 104.203186,3.56094622 104.135289,3.56260556 C104.072075,3.5642649 104.008861,3.564739 103.946115,3.56758358 C103.83748,3.57279866 103.729781,3.58085831 103.622317,3.59034026 C103.604289,3.59176256 103.586262,3.59271075 103.568468,3.59437009 C103.45117,3.60551138 103.334575,3.61926021 103.218682,3.63537952 C103.211424,3.63632772 103.204167,3.63727591 103.196909,3.63822411 C103.075397,3.65529162 102.954587,3.67520371 102.834948,3.69772334 C102.834246,3.69796039 102.83331,3.69796039 102.832607,3.69819744 C101.371187,3.97364808 100.046965,4.64283668 98.9709182,5.5917428 C98.9681087,5.59435034 98.965065,5.59672083 98.9622555,5.59932836 C98.8779698,5.67376167 98.7955572,5.75009136 98.7145493,5.82784335 C98.7058866,5.83637711 98.6972239,5.84467381 98.6885612,5.85297052 C98.6117675,5.92740382 98.5363787,6.00349647 98.4623946,6.08077436 C98.4504541,6.09310089 98.4389819,6.10566448 98.4272756,6.11799101 C98.3558669,6.19360956 98.2858629,6.27017631 98.2174979,6.34840239 C98.204855,6.36286236 98.1924463,6.37755939 98.1800376,6.39201936 C98.1128431,6.4700084 98.0463511,6.54894563 97.9819662,6.6295422 C97.9714305,6.64281693 97.961363,6.65632871 97.9508273,6.66960344 C97.8850377,6.75304459 97.8201845,6.8371969 97.7574385,6.92300854 C97.7555655,6.92561608 97.7539266,6.92798657 97.7520536,6.9305941 C97.55726,7.19822213 97.3790895,7.47888785 97.2168395,7.76974665 C97.2025578,7.79558497 97.1871054,7.82071213 97.1730578,7.8467875 C97.136534,7.91387229 97.1023515,7.98214233 97.0677007,8.05041237 C97.044288,8.09639982 97.0201729,8.14191318 96.9976968,8.18837473 C96.9674944,8.25071855 96.9389309,8.31448467 96.9101333,8.37777668 C96.8857841,8.4313497 96.8612008,8.48492271 96.8380222,8.53920687 C96.8118,8.6001284 96.7872167,8.66152403 96.7626334,8.7231567 C96.7392207,8.78170774 96.7160421,8.84002173 96.6940342,8.89904687 C96.671558,8.95878315 96.6502525,9.01923058 96.629181,9.07967801 C96.6074072,9.14225888 96.5863358,9.20483975 96.5662009,9.26789471 C96.5472366,9.32691985 96.5287406,9.38618203 96.5111811,9.44591832 C96.4917485,9.51181787 96.4732525,9.57842856 96.4552248,9.64503926 C96.4395383,9.70335325 96.4240859,9.76190429 96.40957,9.82069238 C96.3924787,9.89062176 96.3767922,9.96102524 96.3613399,10.0316658 C96.3489311,10.0885575 96.3362883,10.1454492 96.3250502,10.202815 C96.3103002,10.2781965 96.2974232,10.3540521 96.2847804,10.4299076 C96.2756494,10.4837177 96.2658161,10.5375278 96.2578558,10.5918119 Z M11.6624252,92.4418984 L75.9979194,92.4418984 C75.9649075,92.4068152 75.9335345,92.3698355 75.9009909,92.3342782 C75.8553361,92.284498 75.8099155,92.2344807 75.7651973,92.1837523 C75.6987052,92.1083708 75.6331497,92.0320411 75.5685307,91.9547632 C75.5252172,91.9030866 75.4819037,91.8514099 75.4392927,91.7990222 C75.3746736,91.7193738 75.3114594,91.637829 75.2487134,91.5560472 C75.2089118,91.5041335 75.1688761,91.452931 75.1297769,91.4003062 C75.0646896,91.3128352 75.0019436,91.2234678 74.9391976,91.1338634 C74.9050151,91.0847943 74.8698961,91.0366734 74.8361818,90.9871302 C74.7633683,90.8797471 74.6928961,90.7702306 74.6233604,90.660003 C74.602289,90.6265791 74.580047,90.5943405 74.5592097,90.5606795 C74.4700073,90.4165539 74.3836145,90.2700578 74.3000312,90.1211912 C74.2777891,90.081604 74.2569519,90.0408316 74.2351781,90.0007704 C74.1750074,89.8907798 74.1153051,89.7805521 74.0581781,89.6684281 C74.0282099,89.60964 74.0003488,89.5499037 73.971317,89.4906415 C73.9247258,89.3951109 73.8779004,89.2993432 73.8334163,89.2021532 C73.8032139,89.1362536 73.7744163,89.0694059 73.7453846,89.0027952 C73.7048806,88.9098721 73.6646108,88.816949 73.6259799,88.7228406 C73.5974164,88.6529113 73.5700236,88.5822707 73.5423966,88.5116302 C73.5061069,88.4187071 73.4707538,88.3253099 73.4365712,88.2309645 C73.4101149,88.1584276 73.3845951,88.0854166 73.3595435,88.0121685 C73.3269998,87.917112 73.2953927,87.8213443 73.2649562,87.7251025 C73.2415435,87.6516174 73.218365,87.5778952 73.196357,87.5036989 C73.1668571,87.4048496 73.1392301,87.3050521 73.1118372,87.2050175 C73.0919364,87.1320065 73.0715674,87.0589955 73.0528373,86.9852733 C73.0259127,86.8802608 73.0013293,86.7738259 72.9769801,86.667391 C72.9610595,86.5972246 72.9439683,86.5275322 72.9289841,86.4566546 C72.9036984,86.3386044 72.8814564,86.2188948 72.8592143,86.0991851 C72.8479762,86.0387377 72.8353334,85.9792385 72.8250318,85.918554 C72.7938929,85.7374488 72.7657977,85.5551583 72.7416826,85.3709714 L21.7919251,85.3709714 L3.68338077,85.3709714 C4.43844,89.5060497 7.62982365,92.4418984 11.6624252,92.4418984 Z M120.998408,32.7899677 C120.998647,32.8098599 121.000556,32.8297522 120.99984,32.850118 C120.998408,32.9064794 120.993634,32.9621303 120.986951,33.0170708 C120.986712,33.0203861 120.986712,33.0234647 120.986235,33.0267801 C120.975971,33.1077699 120.958785,33.1863916 120.938019,33.2635925 C120.933962,33.2787485 120.929665,33.2934308 120.92513,33.30835 C120.878347,33.4655934 120.810559,33.6131276 120.72463,33.7488211 C120.716514,33.7616089 120.708399,33.77416 120.700045,33.7867111 C120.654455,33.854913 120.605285,33.9202732 120.551102,33.981134 C120.54776,33.9846862 120.54418,33.9880016 120.540838,33.9917906 C120.485939,34.0526514 120.426267,34.1087759 120.363491,34.1615851 C120.358478,34.1658477 120.354659,34.1708208 120.349647,34.1748466 C116.038893,37.7064298 112.307441,41.2448806 107.873046,46.0062306 C102.802778,51.4498371 91.7857706,58.7815489 86.0428726,60.5339606 C83.3864839,61.3445694 81.1912456,61.9366004 79.2545094,62.4594822 C75.5209096,63.4666453 72.7568714,64.2130779 69.3242606,65.8091935 L66.5163033,75.703689 C66.2938436,76.487538 65.5749072,77 64.7927178,77 C64.632079,77 64.4685759,76.9786869 64.3062662,76.9332189 C63.354129,76.6670418 62.7994119,75.6852176 63.0674615,74.7405729 L66.0950142,64.0724114 C66.1009815,64.0513351 66.1074262,64.0304956 66.1141095,64.0098929 C66.2733162,63.5189808 66.4310907,63.0273583 66.589104,62.5354989 C68.5186795,56.5263844 70.5141337,50.3124272 74.8387316,45.4144364 C84.7202875,34.2226827 104.265713,30.6427897 119.255011,31.0276098 C119.339269,31.0297412 119.421379,31.0396873 119.502295,31.0529488 C119.520435,31.0557905 119.538337,31.0588691 119.556239,31.0624213 C119.637155,31.0782877 119.716639,31.0979431 119.793259,31.1239925 C119.793736,31.1239925 119.794214,31.1242293 119.794691,31.1244661 C119.871788,31.1507523 119.945305,31.1836692 120.017151,31.2196647 C120.030995,31.2265323 120.0446,31.233163 120.058205,31.2405042 C120.128619,31.2783942 120.196885,31.3198363 120.261331,31.3662516 C120.269208,31.3719351 120.276369,31.378329 120.284007,31.3840125 C120.341293,31.4268755 120.395714,31.473054 120.447271,31.5223109 C120.459445,31.5339147 120.472095,31.5450449 120.48403,31.5571224 C120.53869,31.6120628 120.58977,31.6703187 120.636792,31.7318899 C120.646101,31.7442042 120.654694,31.7572288 120.663764,31.7697799 C120.706489,31.8287462 120.745635,31.8900806 120.780961,31.9540199 C120.785735,31.9630188 120.791225,31.9713072 120.795998,31.9803061 C120.834189,32.0527707 120.866651,32.1285507 120.894816,32.2064619 C120.896965,32.2126191 120.900545,32.2183026 120.902693,32.2244597 C120.905319,32.2318009 120.906274,32.2396157 120.90866,32.2471937 C120.959502,32.3997009 120.989815,32.5607333 120.996976,32.7279228 C120.997692,32.7487623 120.998169,32.769365 120.998408,32.7899677 Z M77.5340269,47.756511 C75.2953469,50.2920613 73.752689,53.2567157 72.4766485,56.4636291 C76.7888345,52.5955355 82.6281636,48.2464759 88.0376107,44.6611362 C91.3895441,42.4395991 97.3876024,38.6593629 103.660632,35.6411889 C101.191855,36.0456645 98.7963549,36.5581265 96.5295094,37.1757332 C88.0946578,39.4737607 81.7037145,43.0337614 77.5340269,47.756511 Z M105.24172,43.5935859 C108.084287,40.541311 110.64878,37.9761591 113.255998,35.5938264 C107.252689,37.4175187 99.0698944,41.6242541 90.0278137,47.6172653 C84.8055001,51.0785153 79.7992015,54.8284396 75.9309802,58.1760196 C74.9697728,59.0079415 74.1544054,59.7489275 73.4588607,60.4098709 C75.0136919,59.9201429 76.5859475,59.4953014 78.3143067,59.0290178 C80.2245483,58.513714 82.3894729,57.9292611 84.9897693,57.1359395 C89.6492502,55.7143547 100.307028,48.8917896 105.24172,43.5935859 Z" })));

const IconFirst = (p) => (!p.opened ? '0px' : '10px');
const IconMiddle = (p) => (!p.opened ? '1' : '0');
const IconLast = (p) => (!p.opened ? '0px' : '-6px');
const IconRotate = (p) => (!p.opened ? '0deg' : '45deg');
const Icon$3 = styled.div `
  position: relative;
  width: 23px;
  height: 32px;
  transform: translateX(${p => (p.opened ? '-2px' : '-1px')})
    translateY(${p => (p.opened ? '0' : '2px')})
    scale(${p => (p.opened ? 0.8 : 1)});
`;
const sidebarBg = get('colors.sidebarBg');
const sidebarPrimary$2 = get('colors.sidebarPrimary');
const sidebarText$1 = get('colors.sidebarText');
const primaryColor$2 = get('colors.primary');
const backgroundColor = get('colors.background');
const textColor = get('colors.text');
const IconLine = styled.span `
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  right: 0;
  background: ${p => (p.opened ? sidebarText$1(p) : textColor(p))};
  transition: transform 0.3s, opacity 0.3s;

  &:nth-of-type(1) {
    top: -2px;
    transform: translateY(${IconFirst}) rotate(${IconRotate});
  }

  &:nth-of-type(2) {
    top: 6px;
    opacity: ${IconMiddle};
  }

  &:nth-of-type(3) {
    top: 14px;
    transform: translateY(${IconLast}) rotate(-${IconRotate});
  }
`;
const translateX = (p) => (!p.opened ? '10px' : '-6px');
const translateY = (p) => (!p.opened ? '4px' : '0px');
const radii = get('radii');
const ToggleButton = styled.button `
  cursor: pointer;
  z-index: 99;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 6px;
  width: 33px;
  height: 30px;
  top: ${p => (p.opened ? '3px' : '2px')};
  right: ${p => (p.opened ? '-39px' : '-27px')};
  transform: translateX(${translateX}) translateY(${translateY});
  transition: transform 0.3s;
  outline: none;
  border: none;
  background: ${p => (p.opened ? sidebarBg(p) : backgroundColor(p))};
  border-radius: ${p => (p.opened ? `0 0 ${radii(p)} 0` : `${radii(p)}`)};

  &:before {
    position: absolute;
    content: '';
    top: -3px;
    left: 0;
    width: calc(100% + 1px);
    height: ${p => (p.opened ? '3px' : 0)};
    background: ${p => sidebarPrimary$2(p) || primaryColor$2(p)};
  }

  ${mq({
    display: ['block', 'block', 'block', 'none'],
})};
`;
const Hamburguer = ({ opened, onClick }) => (core.jsx(ToggleButton, { opened: opened, onClick: onClick },
    core.jsx(Icon$3, { opened: opened },
        core.jsx(IconLine, { opened: opened }),
        core.jsx(IconLine, { opened: opened }),
        core.jsx(IconLine, { opened: opened }))));

const sidebarBg$1 = get('colors.sidebarBg');
const sidebarText$2 = get('colors.sidebarText');
const sidebarBorder$1 = get('colors.sidebarBorder');
const Wrapper$5 = styled.div `
  position: relative;
  width: 280px;
  min-width: 280px;
  min-height: 100vh;
  background: ${sidebarBg$1};
  transition: transform 0.2s, background 0.3s;
  z-index: 1000;

  ${get('styles.sidebar')};
  ${mq({
    position: ['absolute', 'absolute', 'absolute', 'relative'],
})};

  dl {
    padding: 0;
    margin: 0 16px;
  }

  dl a {
    font-weight: 400;
  }

  @media screen and (max-width: ${breakpoints.desktop - 1}px) {
    transform: translateX(${p => (p.opened ? '-100%' : '0')});
  }
`;
const Content = styled('div') `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 280px;
  min-width: 280px;
  height: 100%;
  max-height: 100vh;
`;
const Menus = styled('nav') `
  flex: 1;
  overflow-y: auto;
  margin-bottom: 10px;
`;
const Empty = styled('div') `
  flex: 1;
  opacity: 0.7;
  padding: 0 24px;
  color: ${sidebarText$2};
`;
const Footer = styled('div') `
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: ${sidebarText$2};
  border-top: 1px dashed ${sidebarBorder$1};
`;
const FooterLink = styled('a') `
  padding: 0;
  margin: 0;
  margin-left: 5px;
`;
const FooterLogo = styled(Docz) `
  fill: ${sidebarText$2};
`;
const ToggleBackground = styled.div `
  content: '';
  display: ${p => (p.opened ? 'none' : 'block')};
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
  z-index: 99;
`;
class SidebarBase extends react.Component {
    constructor() {
        super(...arguments);
        this.state = {
            lastVal: '',
            menus: null,
            searching: false,
            hidden: true,
        };
        this.toggleOverlayClass = () => {
            const { isDesktop } = this.props;
            const { hidden } = this.state;
            const method = !hidden ? this.addOverlayClass : this.removeOverlayClass;
            if (window && typeof window !== 'undefined' && !isDesktop) {
                method();
            }
        };
        this.match = (val, menu) => {
            const items = menu.map(item => [item].concat(item.menu || []));
            const flattened = flattendepth(items, 2);
            return match(flattened, val, { keys: ['name'] });
        };
        this.search = (initial, menus, val) => {
            const change = !val.startsWith(this.state.lastVal);
            this.setState({ lastVal: val });
            return this.match(val, change ? initial : menus);
        };
        this.handleSearchDocs = (initial, menus) => (val) => {
            const isEmpty = val.length === 0;
            this.setState({
                menus: isEmpty ? initial : this.search(initial, menus, val),
                searching: !isEmpty,
            });
        };
        this.handleSidebarToggle = () => {
            if (this.props.isDesktop)
                return;
            this.setState({ hidden: !this.state.hidden });
        };
    }
    componentDidUpdate(pProps, pState) {
        const { isDesktop } = this.props;
        const { hidden } = this.state;
        if (pState.hidden !== this.state.hidden) {
            this.toggleOverlayClass();
        }
        if (pProps.isDesktop !== isDesktop && !hidden && isDesktop) {
            this.setState({ hidden: true });
            this.removeOverlayClass();
        }
    }
    componentDidMount() {
        this.toggleOverlayClass();
    }
    render() {
        const { hidden } = this.state;
        return (core.jsx(docz.Menu, null, initial => {
            const menus = this.state.menus || initial;
            return (core.jsx(react.Fragment, null,
                core.jsx(Wrapper$5, { opened: hidden },
                    core.jsx(Content, null,
                        core.jsx(Hamburguer, { opened: !hidden, onClick: this.handleSidebarToggle }),
                        core.jsx(Logo, { showBg: !hidden }),
                        core.jsx(Search, { onSearch: this.handleSearchDocs(initial, menus) }),
                        menus.length === 0 ? (core.jsx(Empty, null, "No documents found.")) : (core.jsx(Menus, null, menus.map(menu => (core.jsx(Menu, { key: menu.id, item: menu, sidebarToggle: this.handleSidebarToggle, collapseAll: Boolean(this.state.searching) }))))),
                        core.jsx(Footer, null,
                            "Built with",
                            core.jsx(FooterLink, { href: "https://docz.site", target: "_blank" },
                                core.jsx(FooterLogo, { width: 40 }))))),
                core.jsx(ToggleBackground, { opened: hidden, onClick: this.handleSidebarToggle })));
        }));
    }
    removeOverlayClass() {
        document.documentElement.classList.remove('with-overlay');
    }
    addOverlayClass() {
        document.documentElement.classList.add('with-overlay');
    }
}
const mapSizesToProps = ({ width }) => ({
    isDesktop: width >= breakpoints.desktop,
});
const Sidebar = withSizes(mapSizesToProps)(SidebarBase);

const styles$1 = (props) => core.css `
  @import url('https://unpkg.com/rc-tooltip@3.7.3/assets/bootstrap.css');
  @import url('https://unpkg.com/codemirror@5.42.0/lib/codemirror.css');

  .icon-link {
    display: none;
  }

  body {
    margin: 0;
    padding: 0;
    ${getter(props, 'config.themeConfig.styles.body')};
  }

  .with-overlay {
    overflow: hidden;
  }

  html,
  body,
  #root {
    height: 100%;
    min-height: 100%;
  }
`;

const Wrapper$6 = styled('div') `
  display: flex;
  max-width: 100vw;
`;
const Main = props => (core.jsx(Wrapper$6, null,
    core.jsx(core.Global, { styles: styles$1(props) }),
    props.children));

const Wrapper$7 = styled('div') `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  color: ${get('colors.text')};
  background: ${get('colors.background')};
`;
const Title = styled('h1') `
  margin: 0;
  font-size: 42px;
  font-weight: 400;
  color: ${get('colors.primary')};
`;
const Subtitle = styled('p') `
  margin: 0;
  font-size: 18px;
`;
const NotFound = () => (core.jsx(docz.ThemeConfig, null, config => (core.jsx(Main, { config: config },
    core.jsx(Sidebar, null),
    core.jsx(Wrapper$7, null,
        core.jsx(Title, null, "Page Not Found"),
        core.jsx(Subtitle, null, "Check if you haven't changed the document route or deleted it!"))))));

const Paragraph = styled('p') `
  color: ${get('colors.text')};
  ${get('styles.paragraph')};
`;

const BaseButton = styled('button') `
  cursor: pointer;
  display: flex;
  align-items: center;
  outline: none;
  border: none;
`;
const Button = (_a) => {
    var { as: Component = BaseButton } = _a, props = __rest(_a, ["as"]);
    return core.jsx(Component, Object.assign({}, props));
};
const ButtonLink = styled(Button) `
  background: transparent;
`;

const Wrapper$8 = styled('div') `
  flex: 1;
  color: ${get('colors.text')};
  background: ${get('colors.background')};
  font-size: 18px;
  min-width: 0;
`;
const Container = styled('div') `
  box-sizing: border-box;
  margin: 0 auto;
  ${p => mq(get('styles.container')(p))};
`;
const EditPage = styled(ButtonLink.withComponent('a')) `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  padding: 2px 8px;
  margin: 8px;
  border-radius: ${get('radii')};
  border: 1px solid ${get('colors.border')};
  opacity: 0.7;
  transition: opacity 0.4s;
  font-size: 14px;
  color: ${get('colors.text')};
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    opacity: 1;
    background: ${p => lighten(0.1, get('colors.border', '#CED4DE')(p))};
  }

  ${mq({
    visibility: ['hidden', 'hidden', 'visible'],
    top: [0, -60, 32],
    right: [0, 0, 40],
})};
`;
const EditIcon = styled(Edit) `
  margin-right: 5px;
`;
const Page = ({ children, doc: { link, fullpage, edit = true }, }) => {
    const content = (core.jsx(react.Fragment, null,
        link && edit && (core.jsx(EditPage, { href: link, target: "_blank" },
            core.jsx(EditIcon, { width: 14 }),
            " Edit page")),
        children));
    return (core.jsx(docz.ThemeConfig, null, (_a) => {
        var { repository } = _a, config = __rest(_a, ["repository"]);
        return (core.jsx(Main, { config: config },
            repository && core.jsx(GithubLink, { repository: repository }),
            !fullpage && core.jsx(Sidebar, null),
            core.jsx(Wrapper$8, null, fullpage ? content : core.jsx(Container, null, content))));
    }));
};

const theme = () => core.css `
  .cm-s-docz-light.CodeMirror {
    border-radius: 0;
    background: #fbfcfd;
    color: #24292e;
  }

  .cm-s-docz-light .CodeMirror-gutters {
    background: #fbfcfd;
    border-right-width: 0;
    border-radius: 0;
  }

  .cm-s-docz-light .CodeMirror-guttermarker {
    color: white;
  }

  .cm-s-docz-light .CodeMirror-guttermarker-subtle {
    color: #d0d0d0;
  }

  .cm-s-docz-light .CodeMirror-linenumber {
    color: #959da5;
    background: #fbfcfd;
  }

  .cm-s-docz-light .CodeMirror-cursor {
    border-left: 1px solid #24292e;
  }

  .cm-s-docz-light div.CodeMirror-selected,
  .cm-s-docz-light .CodeMirror-line::selection,
  .cm-s-docz-light .CodeMirror-line > span::selection,
  .cm-s-docz-light .CodeMirror-line > span > span::selection,
  .cm-s-docz-light .CodeMirror-line::-moz-selection,
  .cm-s-docz-light .CodeMirror-line > span::-moz-selection,
  .cm-s-docz-light .CodeMirror-line > span > span::-moz-selection {
    background: #c8c8fa;
  }

  .cm-s-docz-light .CodeMirror-activeline-background {
    background: #fafbfc;
  }

  .cm-s-docz-light .CodeMirror-matchingbracket {
    text-decoration: underline;
    color: #949495 !important;
  }

  .cm-s-docz-light .CodeMirror-lines {
    background: #fbfcfd;
  }

  .cm-s-docz-light .cm-comment {
    color: #6a737d;
  }

  .cm-s-docz-light .cm-tag,
  .cm-s-docz-light .cm-bracket {
    color: #d73a49;
  }

  .cm-s-docz-light .cm-constant {
    color: #005cc5;
  }

  .cm-s-docz-light .cm-entity {
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    color: #6f42c1;
  }

  .cm-s-docz-light .cm-keyword {
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    color: #d73a49;
  }

  .cm-s-docz-light .cm-storage {
    color: #d73a49;
  }

  .cm-s-docz-light .cm-string {
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    color: #005cc5;
  }

  .cm-s-docz-light .cm-support {
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    color: #005cc5;
  }

  .cm-s-docz-light .cm-variable {
    font-weight: normal;
    font-style: normal;
    text-decoration: none;
    color: #e36209;
  }
`;

const theme$1 = () => core.css `
  .CodeMirror.cm-s-docz-dark {
    color: #d8dee9;
    background-color: #2e3440;
    border-radius: 0;
  }
  .cm-s-docz-dark .CodeMirror-selected {
    background-color: rgba(67, 76, 94, 0.8);
  }
  .cm-s-docz-dark .CodeMirror-gutter,
  .cm-s-docz-dark .CodeMirror-gutters {
    border: none;
    background-color: #2e3440;
    border-radius: 0;
  }
  .cm-s-docz-dark .CodeMirror-linenumber,
  .cm-s-docz-dark .CodeMirror-linenumbers {
    color: rgba(216, 222, 233, 0.4) !important;
    background-color: #2e3440;
  }
  .cm-s-docz-dark .CodeMirror-lines {
    color: #d8dee9 !important;
    background-color: transparent;
  }
  .cm-s-docz-dark .CodeMirror-cursor {
    border-left: 2px solid #d8dee9 !important;
  }
  /* addon: edit/machingbrackets.js & addon: edit/matchtags.js */
  .cm-s-docz-dark .CodeMirror-matchingbracket,
  .cm-s-docz-dark .CodeMirror-matchingtag {
    border-bottom: 2px solid #81a1c1;
    color: #d8dee9 !important;
    background-color: transparent;
  }
  .cm-s-docz-dark .CodeMirror-nonmatchingbracket {
    border-bottom: 2px solid #bf616a;
    color: #d8dee9 !important;
    background-color: transparent;
  }
  /* addon: fold/foldgutter.js */
  .cm-s-docz-dark .CodeMirror-foldmarker,
  .cm-s-docz-dark .CodeMirror-foldgutter,
  .cm-s-docz-dark .CodeMirror-foldgutter-open,
  .cm-s-docz-dark .CodeMirror-foldgutter-folded {
    border: none;
    text-shadow: none;
    color: #d8dee9 !important;
    background-color: transparent;
  }
  /* addon: selection/active-line.js */
  .cm-s-docz-dark .CodeMirror-activeline-background {
    background-color: rgba(67, 76, 94, 0.32);
  }
  /* basic syntax */
  .cm-s-docz-dark .cm-attribute {
    color: #8fbcbb;
  }
  .cm-s-docz-dark .cm-keyword {
    color: #81a1c1;
  }
  .cm-s-docz-dark .cm-def {
    color: #d8dee9;
  }
  .cm-s-docz-dark .cm-atom {
    color: #81a1c1;
  }
  .cm-s-docz-dark .cm-number {
    color: #b48ead;
  }
  .cm-s-docz-dark .cm-property {
    color: #d8dee9;
  }
  .cm-s-docz-dark .cm-qualifier {
    color: #88c0d0;
  }
  .cm-s-docz-dark .cm-variable,
  .cm-s-docz-dark .cm-variable-2 {
    color: #88c0d0;
  }
  .cm-s-docz-dark .cm-variable-3 {
    color: #d8dee9;
  }
  .cm-s-docz-dark .cm-string,
  .cm-s-docz-dark .cm-string-2 {
    color: #a3be8c;
  }
  .cm-s-docz-dark .cm-operator {
    color: #81a1c1;
  }
  .cm-s-docz-dark .cm-meta {
    color: #81a1c1;
  }
  .cm-s-docz-dark .cm-comment {
    color: #4c566a;
  }
  .cm-s-docz-dark .cm-error {
    color: #bf616a;
  }
  /* markdown */
  .cm-s-docz-dark .cm-header {
    color: #88c0d0;
  }
  .cm-s-docz-dark .cm-quote {
    color: #4c566a;
  }
  .cm-s-docz-dark .cm-link {
    color: #88c0d0;
    text-decoration: none;
  }
  .cm-s-docz-dark .cm-url {
    color: #d8dee9;
    text-decoration: underline;
  }
  .cm-s-docz-dark .cm-strong {
    font-weight: bold;
  }
  .cm-s-docz-dark .cm-em {
    font-style: italic;
  }
  /* diff */
  .cm-s-docz-dark .cm-negative {
    color: #bf616a;
  }
  .cm-s-docz-dark .cm-positive {
    color: #a3be8c;
  }
  /* html */
  .cm-s-docz-dark .cm-tag {
    color: #81a1c1;
  }
`;

const global = (core.jsx(core.Global, { styles: core.css `
      /*
       * Container style
       */
      .ps {
        overflow: hidden !important;
        overflow-anchor: none;
        -ms-overflow-style: none;
        touch-action: auto;
        -ms-touch-action: auto;
      }
      /*
       * Scrollbar rail styles
       */
      .ps__rail-x {
        display: none;
        opacity: 0;
        transition: background-color 0.2s linear, opacity 0.2s linear;
        -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
        height: 15px;
        /* there must be 'bottom' or 'top' for ps__rail-x */
        bottom: 0px;
        /* please don't change 'position' */
        position: absolute;
      }
      .ps__rail-y {
        display: none;
        opacity: 0;
        transition: background-color 0.2s linear, opacity 0.2s linear;
        -webkit-transition: background-color 0.2s linear, opacity 0.2s linear;
        width: 15px;
        /* there must be 'right' or 'left' for ps__rail-y */
        right: 0;
        /* please don't change 'position' */
        position: absolute;
      }
      .ps--active-x > .ps__rail-x,
      .ps--active-y > .ps__rail-y {
        display: block;
        background-color: transparent;
      }
      /*
       * Scrollbar thumb styles
       */
      .ps__thumb-x {
        background-color: #aaa;
        border-radius: 4px;
        transition: background-color 0.2s linear, height 0.2s ease-in-out;
        -webkit-transition: background-color 0.2s linear,
          height 0.2s ease-in-out;
        height: 6px;
        /* there must be 'bottom' for ps__thumb-x */
        bottom: 2px;
        /* please don't change 'position' */
        position: absolute;
      }
      .ps__thumb-y {
        background-color: #aaa;
        border-radius: 4px;
        transition: background-color 0.2s linear, width 0.2s ease-in-out;
        -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
        width: 6px;
        /* there must be 'right' for ps__thumb-y */
        right: 2px;
        /* please don't change 'position' */
        position: absolute;
      }
      .ps__rail-x:hover > .ps__thumb-x,
      .ps__rail-x:focus > .ps__thumb-x,
      .ps__rail-x.ps--clicking .ps__thumb-x {
        background-color: #999;
        height: 11px;
      }
      .ps__rail-y:hover > .ps__thumb-y,
      .ps__rail-y:focus > .ps__thumb-y,
      .ps__rail-y.ps--clicking .ps__thumb-y {
        background-color: #999;
        width: 11px;
      }
      /* MS supports */
      @supports (-ms-overflow-style: none) {
        .ps {
          overflow: auto !important;
        }
      }
      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
        .ps {
          overflow: auto !important;
        }
      }
      .scrollbar-container {
        position: relative;
        height: 100%;
      }
    ` }));

const Scrollbar = styled(PerfectScrollbar) `
  overflow: auto;
  position: relative;
  max-height: ${p => 25 * p.linesToScroll}px;

  .ps__rail-y {
    z-index: 9;
    opacity: 0.4;
  }
`;
const preStyles = get('styles.pre');
const EditorStyled = styled(reactCodemirror2.Controlled) `
  ${theme$1()};
  ${theme()};
  ${p => mq(preStyles(p))};
  position: relative;
  flex: 1;

  .CodeMirror {
    max-width: 100%;
    height: 100%;
  }

  .CodeMirror pre {
    ${p => mq(preStyles(p))};
  }

  .CodeMirror-gutters {
    left: 1px !important;
  }

  .CodeMirror-lines {
    padding: 10px 0;
  }

  .CodeMirror-line {
    padding: 0 10px;
  }

  .CodeMirror-linenumber {
    padding: 0 7px 0 5px;
  }
`;
const scrollbarOpts = {
    wheelSpeed: 2,
    wheelPropagation: true,
    minScrollbarLength: 20,
    suppressScrollX: true,
};
const CodeMirror = props => (core.jsx(docz.ThemeConfig, null, ({ themeConfig }) => (core.jsx(Scrollbar, { option: scrollbarOpts, linesToScroll: themeConfig.linesToScrollEditor || 14 },
    global,
    core.jsx(EditorStyled, Object.assign({}, props))))));

const ButtonSwap = (_a) => {
    var { as: Button$$1 = Button, onClick, swap, children } = _a, props = __rest(_a, ["as", "onClick", "swap", "children"]);
    return (core.jsx(reactPowerplug.Toggle, null, ({ toggle, on }) => {
        const Btn = Button$$1;
        const hasSwap = Boolean(swap);
        const handleClick = (ev) => {
            hasSwap && toggle();
            onClick && onClick(ev);
            hasSwap && setTimeout(toggle, 500);
        };
        return (core.jsx(Btn, Object.assign({ onClick: handleClick }, props), on ? swap : children));
    }));
};

const textColor$1 = get('colors.text', '#2D3747');
const ActionButton = styled(ButtonSwap) `
  padding: 4px;
  background: transparent;
  font-size: 12px;
  text-transform: uppercase;
  color: ${p => rgba(textColor$1(p), 0.4)};
  transition: color 0.3s;

  &:hover {
    color: ${p => rgba(textColor$1(p), 0.7)};
  }
`;
const Check = styled(BaseCheck) `
  stroke: ${get('colors.primary')};
`;
const ClipboardAction = (_a) => {
    var { content } = _a, props = __rest(_a, ["content"]);
    return (core.jsx(ActionButton, Object.assign({}, props, { as: ButtonLink, title: "Copy to clipboard", onClick: () => copy(content), swap: core.jsx(Check, { width: 17 }) }),
        core.jsx(Clipboard, { width: 15 })));
};

const getLanguage = (children) => {
    const defaultLanguage = 'jsx';
    if (typeof children === 'string')
        return defaultLanguage;
    const language = getter(children, 'props.props.className') || defaultLanguage;
    const result = language.replace('language-', '');
    if (result === 'js' || result === 'javascript')
        return 'jsx';
    if (result === 'ts' || result === 'tsx' || result === 'typescript') {
        return 'text/typescript';
    }
    return result;
};
const getChildren = (children) => children && typeof children !== 'string'
    ? getter(children, 'props.children')
    : children;
const Wrapper$9 = styled('div') `
  margin: 30px 0;
  position: relative;
  width: 100%;
  border: 1px solid ${get('colors.border')};
`;
const Actions = styled('div') `
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 10px;
  background: transparent;
`;
class Editor extends react.Component {
    constructor() {
        super(...arguments);
        this.state = {
            code: getChildren(this.props.children),
        };
        this.onEditorDidMount = (editor) => {
            if (editor) {
                this.removeLastLine(editor);
                editor.refresh();
            }
        };
        this.removeLastLine = (editor) => {
            if (editor && !this.props.withLastLine && this.props.readOnly) {
                const lastLine = editor.lastLine();
                editor.doc.replaceRange('', { line: lastLine - 1 }, { line: lastLine });
            }
        };
        this.handleChange = (editor, data, code) => {
            this.props.onChange && this.props.onChange(code);
            this.setState({ code });
        };
    }
    render() {
        const { code } = this.state;
        const _a = this.props, { mode, children, actions, onChange, className, editorClassName, language: defaultLanguage } = _a, props = __rest(_a, ["mode", "children", "actions", "onChange", "className", "editorClassName", "language"]);
        const language = defaultLanguage || getLanguage(children);
        const options = Object.assign({}, props, { tabSize: 2, mode: language || mode, lineNumbers: true, lineWrapping: true, autoCloseTags: true, theme: 'docz-light' });
        const editorProps = (config) => ({
            value: this.state.code,
            className: editorClassName,
            editorDidMount: this.onEditorDidMount,
            onBeforeChange: this.handleChange,
            options: Object.assign({}, options, { theme: config && config.themeConfig
                    ? config.themeConfig.codemirrorTheme
                    : options.theme }),
        });
        return (core.jsx(Wrapper$9, { className: className },
            core.jsx(docz.ThemeConfig, null, config => core.jsx(CodeMirror, Object.assign({}, editorProps(config)))),
            core.jsx(Actions, null, actions || core.jsx(ClipboardAction, { content: code }))));
    }
}
Editor.defaultProps = {
    mode: 'js',
    readOnly: true,
    matchBrackets: true,
    indentUnit: 2,
};

const Pre = (props) => core.jsx(Editor, Object.assign({}, props));

const HANDLE_SIZE = '20px';
const borderColor = get('colors.border');
const preBg = get('colors.preBg');
const mode = get('mode');
const line = (position) => (p) => core.css `
  content: '';
  position: absolute;
  display: block;
  top: ${p.horizontal ? '50%' : position};
  left: ${p.horizontal ? position : '50%'};
  width: ${p.horizontal ? '2px' : '25px'};
  height: ${p.horizontal ? '25px' : '2px'};
  background: ${mode(p) === 'light'
    ? darken(0.05, borderColor(p))
    : lighten(0.06, borderColor(p))};
  transform: translate(-50%, -50%);
`;
const whenHorizontal = (on, off) => (p) => p.horizontal ? on : off;
const handleHeight = (p) => p.horizontal ? `calc(100% ${p.full ? '+ 3px' : '- 2px'})` : HANDLE_SIZE;
const Handle = styled('div') `
  z-index: ${p => (p.full ? (p.horizontal ? 9999 : 9998) : 9)};
  position: absolute;
  display: block;
  width: ${whenHorizontal(HANDLE_SIZE, 'calc(100% + 3px)')};
  height: ${handleHeight};
  border: 1px solid ${p => lighten(0.03, borderColor(p))};
  border-radius: ${whenHorizontal('0 4px 4px 0', '0 0 4px 4px')};
  background: ${p => darken(0.01, preBg(p))};

  ${whenHorizontal(`
      top: 0;
      right: 0;
    `, `
      bottom: 0;
      left: 0;
    `)};

  &:after {
    ${line('calc(50% + 3px)')};
  }

  &:before {
    ${line('calc(50% - 3px)')};
  }
`;

const Wrapper$a = styled('div') `
  position: absolute;
  top: 10px;
  left: 50%;
  margin-bottom: 5px;
  transform: translateX(-50%);
`;
const Buttons = styled('div') `
  display: flex;
  background: ${get('colors.background')};
  border: 1px solid ${get('colors.border')};
  border-radius: ${get('radii')};
  padding: 3px 5px;
`;
const ResizeBar = ({ onChangeSize }) => (core.jsx(Wrapper$a, null,
    core.jsx(Buttons, null,
        core.jsx(ActionButton, { onClick: () => onChangeSize('360px', '640px'), title: "Smartphone" },
            core.jsx(Smartphone, { width: 20 })),
        core.jsx(ActionButton, { onClick: () => onChangeSize('768px', '1024px'), title: "Tablet" },
            core.jsx(Tablet, { width: 20 })),
        core.jsx(ActionButton, { onClick: () => onChangeSize('1366px', '1024px'), title: "Monitor" },
            core.jsx(Monitor, { width: 20 })))));

const CodeSandboxLogo = (props) => (core.jsx("svg", Object.assign({}, props, { viewBox: "0 0 512 512" }),
    core.jsx("path", { d: "M69.2898098,165.083974 L69.2898098,276.649443 L152.161311,324.692718 L152.161311,412.603224 L241.327633,463.829131 L241.327633,264.06328 L69.2898098,165.083974 Z M89.0172642,137.098529 L260.121958,235.540974 L427.640018,138.456525 L339.210941,87.2017661 L262.258901,131.853758 L179.736828,84.2839889 L89.0172642,137.098529 Z M272.206216,463.739666 L370.845646,406.905256 L370.845646,322.809124 L444.244039,280.276172 L444.244039,167.397587 L272.206216,266.116045 L272.206216,463.739666 Z M255.633239,512 L34,384.729507 L34,128.977638 L255.644267,0 L477.328236,128.432852 L477.328236,384.321468 L255.633239,512 Z", fill: "currentColor" })));

const localStorage = () => ({
    get: (key) => {
        return window.localStorage.getItem(key);
    },
    set: (key, val) => {
        window.localStorage.setItem(key, val);
    },
    remove: (key) => {
        window.localStorage.removeItem(key);
    },
});

const whenFullscreen = (on, off) => (p) => p.full ? on : off;
const Overlay = styled('div') `
  box-sizing: border-box;
  z-index: ${whenFullscreen(9999, 0)};
  position: ${whenFullscreen('fixed', 'relative')};
  top: 0;
  left: 0;
  width: ${whenFullscreen('100vw', 'auto')};
  height: ${whenFullscreen('100vh', 'auto')};
  padding: ${whenFullscreen('60px 20px 20px', '0px')};
  margin: ${whenFullscreen('0px', '0 0 30px')};
  background: ${whenFullscreen('rgba(0,0,0,0.5)', 'transparent')};
  transition: background 0.3s;
`;
const minusHandleSize = `calc(100% - ${HANDLE_SIZE} + 4px)`;
const Wrapper$b = styled('div') `
  display: flex;
  flex-direction: column;
  height: ${whenFullscreen(minusHandleSize, '100%')};
  width: ${minusHandleSize};
`;
const borderColor$1 = get('colors.border');
const backgroundColor$1 = get('colors.background');
const PreviewWrapper = styled('div') `
  position: relative;
  flex: 1;
  border: 1px solid ${borderColor$1};
  background: ${backgroundColor$1};
  min-height: ${whenFullscreen('198px', 'auto')};
`;
const StyledPreview = styled(reactLive.LivePreview) `
  position: relative;
  box-sizing: border-box;
  width: 100%;
  ${p => mq(get('styles.playground')(p))};
`;
const StyledError = styled(reactLive.LiveError) `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 20px;
  background: ${rgba('black', 0.8)};
  font-size: 16px;
  color: white;
`;
const Pre$1 = styled(Editor) `
  width: calc(100% - 2px);
  border-radius: 0 !important;
  margin: 0;
`;
const EditorWrapper = styled('div') `
  max-height: ${p => (p.showing ? '9999px' : '0px')};
  transform: scaleY(${p => (p.showing ? '1' : '0')});
  transform-origin: top center;
`;
const editorStyle = core.css `
  border-top: 0;
`;
const Actions$1 = styled('div') `
  display: flex;
  justify-content: flex-end;
  padding: 0 5px;
  background: ${p => get('mode')(p) === 'light'
    ? lighten(0.13, borderColor$1(p))
    : darken(0.04, borderColor$1(p))};
  border-left: 1px solid ${get('colors.border')};
  border-bottom: 1px solid ${get('colors.border')};
`;
const actionClass = (p) => core.css `
  padding: 3px 10px;
  border-left: 1px solid ${borderColor$1(p)};
`;
const Action = styled(ActionButton) `
  ${actionClass};
`;
const ActionLink = Action.withComponent('a');
const Clipboard$1 = styled(ClipboardAction) `
  ${actionClass};
`;
const storage = localStorage();
const get$1 = (pos) => storage.get(pos.toString());
const remove = (pos) => storage.remove(pos.toString());
const set = (pos, size) => storage.set(pos.toString(), size);
const parse = (position, key, defaultValue) => {
    const obj = JSON.parse(get$1(position));
    return obj ? getter(obj, key) : defaultValue;
};
class RenderBase extends react.Component {
    constructor() {
        super(...arguments);
        this.state = {
            fullscreen: parse(this.props.position, 'fullscreen', false),
            width: parse(this.props.position, 'width', '100%'),
            height: parse(this.props.position, 'height', '100%'),
            code: this.props.code,
            key: 0,
            showEditor: Boolean(this.props.showEditor),
        };
        this.unloadListener = () => remove(this.props.position);
        this.addUnloadListener = () => {
            if (window && typeof window !== 'undefined') {
                window.addEventListener('beforeunload', this.unloadListener, false);
            }
        };
        this.removeUnloadListener = () => {
            if (window && typeof window !== 'undefined') {
                window.removeEventListener('beforeunload', this.unloadListener, false);
            }
        };
        this.setSize = (fullscreen) => {
            set(this.props.position, JSON.stringify(Object.assign({}, this.state, { fullscreen })));
        };
        this.handleToggle = () => {
            const { position } = this.props;
            const { fullscreen } = this.state;
            if (fullscreen)
                remove(position);
            else
                this.setSize(true);
            this.setState({
                fullscreen: parse(position, 'fullscreen', false),
                width: parse(position, 'width', '100%'),
                height: parse(position, 'height', '100%'),
            });
        };
        this.handleShowEditorToggle = () => {
            this.setState(state => ({ showEditor: !state.showEditor }));
        };
        this.closeOnEsc = () => {
            this.state.fullscreen && this.handleToggle();
        };
        this.handleSetSize = (width, height) => {
            const fullscreen = parse(this.props.position, 'fullscreen', false);
            this.setState({ width, height }, () => this.setSize(fullscreen));
        };
        this.handleRefresh = () => {
            this.setState(state => ({ key: state.key + 1 }));
        };
        this.transformCode = (code) => {
            if (code.startsWith('()') || code.startsWith('class'))
                return code;
            return `<React.Fragment>${code}</React.Fragment>`;
        };
        this.codesandboxUrl = (native) => {
            const { codesandbox } = this.props;
            const url = 'https://codesandbox.io/api/v1/sandboxes/define';
            return `${url}?parameters=${codesandbox}${native ? `&editorsize=75` : ``}`;
        };
        this.toggleBodyOverlayClass = () => {
            const method = this.state.fullscreen ? 'add' : 'remove';
            document.body.classList[method]('with-overlay');
        };
    }
    componentDidUpdate(pProps, pState) {
        if (pState.fullscreen !== this.state.fullscreen) {
            this.toggleBodyOverlayClass();
        }
    }
    componentDidMount() {
        this.addUnloadListener();
        hotkeys('esc', this.closeOnEsc);
    }
    componentWillUnmount() {
        this.removeUnloadListener();
        hotkeys.unbind('esc');
    }
    get actions() {
        const { fullscreen, showEditor } = this.state;
        const { codesandbox } = this.props;
        return (core.jsx(Actions$1, { withRadius: this.state.showEditor },
            core.jsx(Action, { onClick: this.handleRefresh, title: "Refresh playground" },
                core.jsx(Refresh, { width: 15 })),
            core.jsx(docz.ThemeConfig, null, config => config.codeSandbox &&
                codesandbox !== 'undefined' && (core.jsx(ActionLink, { href: this.codesandboxUrl(config.native), target: "_blank", title: "Open in CodeSandbox" },
                core.jsx(CodeSandboxLogo, { style: { height: '100%' }, width: 15 })))),
            core.jsx(Clipboard$1, { content: this.state.code }),
            core.jsx(Action, { onClick: this.handleToggle, title: fullscreen ? 'Minimize' : 'Maximize' }, fullscreen ? core.jsx(Minimize, { width: 15 }) : core.jsx(Maximize, { width: 15 })),
            core.jsx(Action, { onClick: this.handleShowEditorToggle, title: showEditor ? 'Close editor' : 'Show editor' },
                core.jsx(Code, { width: 15 }))));
    }
    get resizableProps() {
        const { fullscreen, width, height } = this.state;
        return {
            minHeight: fullscreen ? 360 : '100%',
            minWidth: 260,
            maxWidth: '100%',
            maxHeight: '100%',
            size: {
                width,
                height,
            },
            style: {
                margin: '0 auto ',
            },
            enable: {
                top: false,
                right: true,
                bottom: fullscreen,
                left: false,
                topRight: false,
                bottomRight: fullscreen,
                bottomLeft: false,
                topLeft: false,
            },
            handleComponent: {
                right: () => core.jsx(Handle, { full: fullscreen, horizontal: true }),
                bottom: () => core.jsx(Handle, { full: fullscreen, horizontal: false }),
            },
            onResizeStop: (e, direction, ref, d) => {
                const width = ref.style.width;
                const height = ref.style.height;
                this.handleSetSize(width, height);
            },
        };
    }
    render() {
        const { className, style, scope } = this.props;
        const { fullscreen, showEditor } = this.state;
        const editorProps = {
            css: editorStyle,
            actions: core.jsx(react.Fragment, null),
        };
        return (core.jsx(reactLive.LiveProvider, { code: this.state.code, scope: scope, transformCode: this.transformCode, mountStylesheet: false },
            core.jsx(Overlay, { full: fullscreen },
                fullscreen ? core.jsx(ResizeBar, { onChangeSize: this.handleSetSize }) : null,
                core.jsx(Resizable, Object.assign({}, this.resizableProps),
                    core.jsx(Wrapper$b, { full: fullscreen },
                        core.jsx(PreviewWrapper, { full: fullscreen },
                            core.jsx(StyledPreview, { className: className, style: style }),
                            core.jsx(StyledError, null)),
                        this.actions,
                        core.jsx(EditorWrapper, { showing: showEditor },
                            core.jsx(Pre$1, Object.assign({}, editorProps, { onChange: (code) => this.setState({ code }), readOnly: false }), this.state.code)))))));
    }
}
const Render = props => (core.jsx(docz.ThemeConfig, null, config => (core.jsx(RenderBase, Object.assign({}, props, { showEditor: getter(config, 'themeConfig.showPlaygroundEditor') })))));

const Wrapper$c = styled('div') `
  overflow-x: auto;
  padding: 2px;

  ${mq({
    marginBottom: [20, 40],
    maxWidth: ['calc(100vw - 40px)', 'calc(100vw - 80px)', '100%'],
})};
`;
const TableStyled = styled('table') `
  padding: 0;
  table-layout: auto;
  box-shadow: 0 0 0 1px ${get('colors.border')};
  background-color: transparent;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  border-radius: ${get('radii')};
  font-size: 14px;
  color: ${get('colors.tableColor')};
  ${p => mq(get('styles.table')(p))};

  & thead {
    color: ${get('colors.theadColor')};
    background: ${get('colors.theadBg')};
  }

  & thead th {
    font-weight: 400;
    padding: 20px 20px;

    &:nth-of-type(1) {
      ${mq({
    width: ['20%', '20%', '20%', 'auto'],
})};
    }

    &:nth-of-type(2) {
      ${mq({
    width: ['10%', '10%', '10%', 'auto'],
})};
    }

    &:nth-of-type(3) {
      ${mq({
    width: ['10%', '10%', '10%', 'auto'],
})};
    }

    &:nth-of-type(4) {
      ${mq({
    width: ['10%', '10%', '10%', 'auto'],
})};
    }

    &:nth-of-type(5) {
      ${mq({
    width: ['20%', '20%', '20%', 'auto'],
})};
    }
  }

  & tbody td {
    padding: 12px 20px;
    line-height: 2;
    font-weight: 200;
  }

  & tbody > tr {
    display: table-row;
    border-top: 1px solid ${get('colors.border')};
  }

  ${p => mq(get('styles.table')(p))};
`;
const Table = (props) => (core.jsx(Wrapper$c, null,
    core.jsx(TableStyled, Object.assign({}, props))));

const overlayStyle = (colors) => core.css `
  .rc-tooltip-inner {
    background: ${colors.tooltipBg};
    color: ${colors.tooltipColor};
  }

  .rc-tooltip-arrow {
    border-top-color: ${colors.tooltipBg};
  }
`;
const Link$2 = styled('a') `
  text-decoration: none;
  color: ${get('colors.primary')};
`;
const Tooltip = ({ text, children }) => (core.jsx(docz.ThemeConfig, null, config => (core.jsx(core.ClassNames, null, ({ css: css$$1 }) => (core.jsx(BaseTooltip, { placement: "top", trigger: ['hover'], overlay: text, overlayClassName: css$$1(overlayStyle(config.themeConfig.colors)) },
    core.jsx(Link$2, { href: "#", onClick: (ev) => ev.preventDefault() }, children)))))));

const light = Object.assign({}, colors, { primary: blue, text: grayDark, link: blue, footerText: grayDark, sidebarBg: grayExtraLight, sidebarText: dark, sidebarHighlight: null, sidebarBorder: grayLight, background: white, border: grayLight, theadColor: gray, theadBg: grayExtraLight, tableColor: dark, tooltipBg: dark, tooltipColor: grayExtraLight, codeBg: lighten(0.02, grayExtraLight), codeColor: gray, preBg: grayExtraLight, blockquoteBg: grayExtraLight, blockquoteBorder: grayLight, blockquoteColor: gray });
const dark$1 = Object.assign({}, colors, { primary: skyBlue, text: grayExtraLight, link: skyBlue, footerText: grayLight, sidebarBg: dark, sidebarText: grayLight, sidebarHighlight: null, sidebarBorder: grayDark, background: grayExtraDark, border: grayDark, theadColor: gray, theadBg: grayDark, tableColor: grayExtraLight, tooltipBg: dark, tooltipColor: grayExtraLight, codeBg: gray, codeColor: grayExtraLight, preBg: grayDark, blockquoteBg: grayDark, blockquoteBorder: gray, blockquoteColor: gray });

var modes = /*#__PURE__*/Object.freeze({
    light: light,
    dark: dark$1
});

const Theme = () => (core.jsx(docz.ThemeConfig, null, config$$1 => (core.jsx(emotionTheming.ThemeProvider, { theme: prev => (Object.assign({}, prev, { docz: config$$1.themeConfig })) },
    core.jsx(docz.DocPreview, { components: {
            page: Page,
            notFound: NotFound,
            render: Render,
            blockquote: Blockquote,
            h1: H1,
            h2: H2,
            h3: H3,
            h4: H4,
            h5: H5,
            h6: H6,
            hr: Hr,
            ul: UnorderedList,
            ol: OrderedList,
            p: Paragraph,
            a: Link,
            inlineCode: InlineCode,
            loading: Loading,
            table: Table,
            pre: Pre,
            tooltip: Tooltip,
        } })))));
webfont.load({
    google: {
        families: [
            'Source Code Pro',
            'Source Sans Pro:400,600',
            'Poppins:400',
            'Playfair Display:700',
        ],
    },
});
const enhance = docz.theme(config, (_a) => {
    var { mode, codemirrorTheme } = _a, config$$1 = __rest(_a, ["mode", "codemirrorTheme"]);
    return (Object.assign({}, config$$1, { mode, codemirrorTheme: codemirrorTheme || `docz-${mode}`, colors: Object.assign({}, getter(modes, mode), config$$1.colors) }));
});
var index = enhance(Theme);

exports.default = index;
//# sourceMappingURL=index.js.map
